import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col, Form, FormGroup, Input, Button } from 'reactstrap';
import { register } from '../../redux';

import './RegisterForm.css';

import logo  from '../../assets/images/Kronos.svg';

const RegisterForm = ({ tkt_instance_id, hide_logo, appear }) => {
    const { t }    = useTranslation();
    const dispatch = useDispatch();

    const [data, setData] = useState({
        firstname: '',
        lastname: '',
        email: '',
        password: '',
        "password-confirmation": '',
        tkt_instance_id
    });

    const { registerErrorMessage, isRegistering, registerError } = useSelector(state => state.auth);

    const submit = e => {
        e.preventDefault();
        dispatch(register(data));
    }

    return (
        <Form onSubmit={ submit } className={`RegisterForm ${appear ? 'appear' : ''}`}>
            {!hide_logo && (
                <img className="logo" src={logo} alt="logo" />
            )}
            <FormGroup row>
                <Col>
                    <Input
                        required
                        type="text"
                        autoComplete="username firstname"
                        name="firstname"
                        id="firstname"
                        placeholder={t("register.firstname")}
                        value={ data.firstname }
                        onChange={ e => setData({ ...data, firstname: e.target.value }) }
                    />
                </Col>
                <Col>
                    <Input
                        required
                        type="lastname"
                        autoComplete="username lastname"
                        name="lastname"
                        id="lastname"
                        placeholder={t("register.lastname")}
                        value={ data.lastname }
                        onChange={ e => setData({ ...data, lastname: e.target.value }) }
                    />
                </Col>
            </FormGroup>
            <FormGroup row>
                <Col>
                    <Input
                        required
                        type="email"
                        autoComplete="username email"
                        name="email"
                        id="email"
                        placeholder={t("register.email")}
                        value={ data.email }
                        onChange={ e => setData({ ...data, email: e.target.value }) }
                    />
                </Col>
            </FormGroup>
            <FormGroup row>
                <Col>
                    <Input
                        required
                        type="password"
                        autoComplete="current-password"
                        name="password"
                        id="password"
                        placeholder={t("register.password")}
                        value={ data.password }
                        onChange={ e => setData({ ...data, password: e.target.value }) }
                    />
                </Col>
                <Col>
                    <Input
                        required
                        type="password"
                        autoComplete="current-password"
                        name="password-confirmation"
                        id="password-confirmation"
                        placeholder={t("register.password-confirmation")}
                        value={ data['password-confirmation'] }
                        onChange={ e => setData({ ...data, 'password-confirmation': e.target.value }) }
                    />
                </Col>
            </FormGroup>

            <Button className="btn btn-lg btn-block btn-dark">
                {isRegistering ?
                    <span>
                        &nbsp;<i className="fa fa-spinner fa-spin"></i>
                    </span>
                    :
                    <span>{t('register.title')}</span>
                }
            </Button>

            {registerError &&
                <div>
                    <br/>
                    <div className="alert alert-danger">
                        <i className="fa fa-warning"></i>&nbsp;
                        {registerErrorMessage}
                    </div>
                </div>
            }
        </Form>
    );
}

export default RegisterForm;
